import {userConstants} from '../../_constants';

export function searchByCrossOffer(state = {}, action) {
  switch (action.type) {
    case userConstants.SEARCH_BY_CROSS_OFFER_REQUEST:
      return {
        loading: true,
      };
    case userConstants.SEARCH_BY_CROSS_OFFER_SUCCESS:
      return {
        ...action.data,
      };
    case userConstants.SEARCH_BY_CROSS_OFFER_FAILURE:
      return {
        error: action.error,
      };
    case userConstants.RESET_SEARCH_RESULTS:
      return {};

    default:
      return state;
  }
}
